import script from "./changshataiheOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./changshataiheOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./changshataiheOrderRecord.vue?vue&type=style&index=0&id=ee6cd646&lang=scss"

const __exports__ = script;

export default __exports__